export enum EntityTypeEnum {
  BUSINESS = 'BUSINESS',
  INTRODUCER = 'INTRODUCER',
  LENDER = 'LENDER',
}
